import TexEditor from "./TexEditor";

export default TexEditor;
